// @ts-strict-ignore
import React, {useState, useRef} from 'react';
import ReactDOM from 'react-dom';
import {autoUpdate, shift, useFloating} from '@floating-ui/react';

import {useDomEvent} from 'common/hooks/useDomEvent';
import {DisplaySize, Placement} from 'common/components/tooltip/types';
import {TooltipReact} from 'common/components/tooltip';

import styles from './new-tooltip.module.styl';

type Props = {
  text: string;
  size: DisplaySize;
  placement: Placement;
  anchorRef: HTMLDivElement;
};

export function NewTooltip(props: Props) {
  const [showTooltip, setShowTooltip] = useState(false);
  const containerRef = useRef(null);

  const root = document.querySelector(`#tooltips`) || document.body;

  const {refs, floatingStyles} = useFloating({
    placement: `top`,
    middleware: [shift()],
    whileElementsMounted: autoUpdate,
    elements: {reference: props.anchorRef},
  });

  useDomEvent(containerRef.current, `mouseenter`, () => setShowTooltip(true));
  useDomEvent(containerRef.current, `mouseleave`, () => setShowTooltip(false));

  return (
    <>
      <div ref={containerRef} className={styles.tooltipAnchor} />
      {showTooltip &&
        ReactDOM.createPortal(
          <div className={styles.tooltipContainer} ref={refs.setFloating} style={{...floatingStyles}}>
            <TooltipReact forceShow text={props.text} placement={props.placement} size={props.size} />
          </div>,
          root,
        )}
    </>
  );
}
